import { useTranslation } from 'react-i18next';

export default function PrivacyContent() {
  const { i18n } = useTranslation();
  const isZh = i18n.language === 'zh';

  if (isZh) {
    return (
      <div className="space-y-6 text-[#0A2540]/80 text-sm leading-relaxed">
        <section>
          <h3 className="text-base font-semibold text-[#0A2540] mb-2">一、信息收集</h3>
          <p>
            全球科创圆桌联盟（"GTRA"或"主办方"）在您报名参与活动、订阅资讯
            或与我们联系时，会收集您主动提供的个人信息，包括但不限于：
            姓名、邮箱、电话、所属机构、职务、城市及其他必要的报名信息。
          </p>
        </section>

        <section>
          <h3 className="text-base font-semibold text-[#0A2540] mb-2">二、信息使用</h3>
          <p>我们将收集到的信息用于以下目的：</p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>处理活动报名及相关支付；</li>
            <li>向您发送活动通知、议程更新或资料；</li>
            <li>核实身份并防止欺诈；</li>
            <li>改进活动内容及参会体验；</li>
            <li>履行法律法规规定的义务。</li>
          </ul>
        </section>

        <section>
          <h3 className="text-base font-semibold text-[#0A2540] mb-2">三、活动期间影像</h3>
          <p>
            活动现场可能由主办方或受委托的第三方进行摄影、录像、直播或截屏。
            上述影像中可能包含您的形象、声音或其他个人特征。
          </p>
          <p className="mt-2">
            您勾选同意本隐私声明即表示您授权主办方在以下范围内使用前述影像：
          </p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>活动回顾、宣传报道、新闻发布；</li>
            <li>主办方及合作方的官方网站、社交媒体、公众号等渠道；</li>
            <li>未来同类活动的推广宣传材料；</li>
            <li>用于主办方非营利性的对外传播与档案保存。</li>
          </ul>
          <p className="mt-2">
            上述使用均不向您支付额外报酬。如您希望撤回此项授权或要求删除特定影像，
            请通过官方渠道联系主办方，我们将在合理范围内予以处理。
          </p>
        </section>

        <section>
          <h3 className="text-base font-semibold text-[#0A2540] mb-2">四、信息共享</h3>
          <p>
            除以下情况外，我们不会向第三方出售、出租或披露您的个人信息：
          </p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>获得您的明示同意；</li>
            <li>为完成活动所必需（如场地方、支付服务商）；</li>
            <li>法律法规或主管机关要求。</li>
          </ul>
        </section>

        <section>
          <h3 className="text-base font-semibold text-[#0A2540] mb-2">五、信息存储与安全</h3>
          <p>
            我们采取合理的技术与管理措施保护您的个人信息，防止未授权的访问、
            使用或泄露。信息保存期限不超过实现收集目的所必需的时间，
            法律另有规定的除外。
          </p>
        </section>

        <section>
          <h3 className="text-base font-semibold text-[#0A2540] mb-2">六、您的权利</h3>
          <p>您对自己的个人信息享有以下权利：</p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>查询、复制您的个人信息；</li>
            <li>更正不准确的信息；</li>
            <li>请求删除信息；</li>
            <li>撤回先前作出的同意；</li>
            <li>注销报名账户。</li>
          </ul>
          <p className="mt-2">
            如需行使上述权利，请通过本网站公布的官方联系方式提交请求。
          </p>
        </section>

        <section>
          <h3 className="text-base font-semibold text-[#0A2540] mb-2">七、Cookie 与日志</h3>
          <p>
            本网站可能使用 Cookie 或类似技术来识别访问偏好、维护登录状态及
            统计访问数据。您可通过浏览器设置拒绝 Cookie，但部分功能可能因此
            受限。
          </p>
        </section>

        <section>
          <h3 className="text-base font-semibold text-[#0A2540] mb-2">八、声明修订</h3>
          <p>
            本隐私声明可能不时更新，更新后的版本自在本网站发布之日起生效。
            涉及重大变更时，我们将通过显著方式通知您。
          </p>
        </section>

        <section>
          <h3 className="text-base font-semibold text-[#0A2540] mb-2">九、联系我们</h3>
          <p>
            如对本隐私声明或您的个人信息处理有任何疑问，请通过本网站
            公布的官方渠道与主办方联系。
          </p>
        </section>
      </div>
    );
  }

  return (
    <div className="space-y-6 text-[#0A2540]/80 text-sm leading-relaxed">
      <section>
        <h3 className="text-base font-semibold text-[#0A2540] mb-2">1. Information We Collect</h3>
        <p>
          Global Technology Roundtable Alliance ("GTRA" or the "Organizer") collects personal
          information that you voluntarily provide when registering for events, subscribing
          to updates, or contacting us. This may include, but is not limited to: name,
          email, phone number, organization, title, city, and other information required
          for registration.
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold text-[#0A2540] mb-2">2. How We Use Information</h3>
        <p>We use the collected information for the following purposes:</p>
        <ul className="list-disc pl-6 mt-2 space-y-1">
          <li>To process event registrations and related payments;</li>
          <li>To send event notifications, agenda updates, or related materials;</li>
          <li>To verify identity and prevent fraud;</li>
          <li>To improve event content and the attendee experience;</li>
          <li>To fulfill legal and regulatory obligations.</li>
        </ul>
      </section>

      <section>
        <h3 className="text-base font-semibold text-[#0A2540] mb-2">3. Photos and Recordings at Events</h3>
        <p>
          Events may be photographed, recorded, livestreamed, or otherwise captured by the
          Organizer or its authorized third parties. Such media may contain your image,
          voice, or other personal characteristics.
        </p>
        <p className="mt-2">
          By agreeing to this Privacy Notice, you authorize the Organizer to use such
          media in the following ways:
        </p>
        <ul className="list-disc pl-6 mt-2 space-y-1">
          <li>Event recaps, press coverage, and news releases;</li>
          <li>Official websites, social media, and public accounts of the Organizer and partners;</li>
          <li>Promotional materials for future similar events;</li>
          <li>Non-commercial external communications and archives by the Organizer.</li>
        </ul>
        <p className="mt-2">
          Such use does not entitle you to additional compensation. If you wish to
          withdraw this authorization or request removal of specific media, please contact
          the Organizer through the official channels, and we will respond within a
          reasonable scope.
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold text-[#0A2540] mb-2">4. Information Sharing</h3>
        <p>
          We do not sell, rent, or disclose your personal information to third parties
          except in the following circumstances:
        </p>
        <ul className="list-disc pl-6 mt-2 space-y-1">
          <li>With your explicit consent;</li>
          <li>As necessary to deliver the event (e.g., venue providers, payment processors);</li>
          <li>As required by law or competent authorities.</li>
        </ul>
      </section>

      <section>
        <h3 className="text-base font-semibold text-[#0A2540] mb-2">5. Data Storage and Security</h3>
        <p>
          We implement reasonable technical and organizational measures to protect your
          personal information from unauthorized access, use, or disclosure. Information
          is retained only as long as necessary for the purposes for which it was
          collected, unless otherwise required by law.
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold text-[#0A2540] mb-2">6. Your Rights</h3>
        <p>You have the following rights regarding your personal information:</p>
        <ul className="list-disc pl-6 mt-2 space-y-1">
          <li>To access and obtain a copy of your information;</li>
          <li>To correct inaccurate information;</li>
          <li>To request deletion of your information;</li>
          <li>To withdraw consent previously given;</li>
          <li>To deactivate your registration account.</li>
        </ul>
        <p className="mt-2">
          To exercise these rights, please submit a request via the official contact
          channels published on this website.
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold text-[#0A2540] mb-2">7. Cookies and Logs</h3>
        <p>
          This website may use cookies or similar technologies to recognize preferences,
          maintain login sessions, and gather analytics. You may decline cookies via your
          browser settings, though some features may be affected.
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold text-[#0A2540] mb-2">8. Amendments</h3>
        <p>
          This Privacy Notice may be updated from time to time. Revised versions become
          effective upon publication on this website. We will notify you prominently of
          any material changes.
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold text-[#0A2540] mb-2">9. Contact</h3>
        <p>
          For questions regarding this Privacy Notice or our handling of your personal
          information, please contact the Organizer via the official channels published
          on this website.
        </p>
      </section>
    </div>
  );
}
